<template>
  <transition name="fade">
    <slot />
  </transition>
</template>
<script>
export default {
  name: 'FadeTransition',
};
</script>
<style lang="scss">
  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  .fade-enter-active, .fade-leave-active {
    animation-duration: .7s;
    animation-fill-mode: both;
  }

  .fade-enter-active {
    animation-name: fadeIn;
  }

  .fade-leave-active {
    animation-name: fadeOut;
  }
</style>
